import AxiosService from './AxiosService';

class MachineLearningService {
  constructor() {
    if (!MachineLearningService.instance) {
      MachineLearningService.instance = this;
    }
    return MachineLearningService.instance;
  }

  serviceEndpoint = 'ml';

  getNewChatSession = async (taskType, context, options) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/chat/session/`,
      { task_type: taskType, context },
      options
    );
    return response.data;
  };

  getChatHistory = async (id, options) => {
    const response = await AxiosService.get(
      `${this.serviceEndpoint}/chat/${id}/`,
      {
        ...options,
      }
    );
    return response.data;
  };

  deleteChatSession = async (id, options) => {
    return AxiosService.delete(
      `${this.serviceEndpoint}/chat/${id}/remove_session/`,
      options
    );
  };

  completeChatSession = async (id, options) => {
    return AxiosService.get(
      `${this.serviceEndpoint}/chat/${id}/complete/`,
      options
    );
  };

  cancelChatSession = async (id, options) => {
    return AxiosService.patch(
      `${this.serviceEndpoint}/chat/${id}/cancel/`,
      options
    );
  };

  getChatMetadata = async (options) => {
    const response = await AxiosService.get(
      `${this.serviceEndpoint}/chat/metadata/`,
      options
    );
    return response.data;
  };

  sendMessage = async (id, payload, options) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/chat/${id}/send-message/`,
      payload,
      options
    );
    return response.data;
  };

  getStreamingEndpoint = (id) => {
    return `${import.meta.env.VITE_API_BASE_PATH}/${this.serviceEndpoint}/chat/${id}/send-message-streaming/`;
  };

  startAction = async (taskType) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/actions/start/`,
      {
        params: { task_type: taskType },
      }
    );
    return response.data;
  };

  startFlow = async (payload) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/flow/start/`,
      payload
    );
    return response.data;
  };

  getFlowStatus = async ({
    flowType,
    objectId = '',
    chatSessionId = '',
    flowId = '',
    options = {},
  }) => {
    const params = {
      type: flowType,
      ...(chatSessionId && { session_id: chatSessionId }),
      ...(objectId && { target_object_id: objectId }),
      ...(flowId && { flow_id: flowId }),
    };

    const response = await AxiosService.get(
      `${this.serviceEndpoint}/flow/last/`,
      {
        params,
        ...options,
      }
    );
    return response.data;
  };
}

const instance = new MachineLearningService();
Object.freeze(instance);

export default instance;
